//#region components/avatar/avatar_constants.js
var e = {
	100: "d-avatar--size-100",
	150: "d-avatar--size-150",
	200: "d-avatar--size-200",
	250: "d-avatar--size-250",
	300: "d-avatar--size-300",
	400: "d-avatar--size-400",
	500: "d-avatar--size-500",
	600: "d-avatar--size-600",
	700: "d-avatar--size-700",
	800: "d-avatar--size-800",
	900: "d-avatar--size-900",
	xs: "d-avatar--xs",
	sm: "d-avatar--sm",
	md: "d-avatar--md",
	lg: "d-avatar--lg",
	xl: "d-avatar--xl"
}, t = {
	default: "",
	icon: "d-avatar__icon",
	initials: "d-avatar__initials"
}, n = {
	100: "d-avatar__presence--100",
	150: "d-avatar__presence--150",
	200: "d-avatar__presence--200",
	250: "d-avatar__presence--250",
	300: "d-avatar__presence--300",
	400: "d-avatar__presence--400",
	500: "d-avatar__presence--500",
	xs: "d-avatar__presence--100",
	sm: "d-avatar__presence--200",
	md: "d-avatar__presence--md",
	lg: "d-avatar__presence--lg"
}, r = {
	NONE: "",
	BUSY: "busy",
	AWAY: "away",
	OFFLINE: "offline",
	ACTIVE: "active"
}, i = {
	100: "100",
	150: "100",
	200: "200",
	250: "200",
	300: "300",
	400: "500",
	500: "600",
	600: "600",
	700: "700",
	800: "800",
	900: "800",
	xs: "100",
	sm: "200",
	md: "300",
	lg: "500",
	xl: "600"
}, a = [
	.45,
	.49,
	.54,
	.59,
	.64,
	.69,
	.74,
	.78,
	.82,
	.85
], o = [
	.08,
	.12,
	.15,
	.17,
	.18,
	.17,
	.15,
	.12,
	.1,
	.08
], s = {
	1: 0,
	2: 30,
	3: 60,
	4: 90,
	5: 120,
	6: 150,
	7: 180,
	8: 210,
	9: 240,
	10: 270,
	11: 300,
	12: 330
}, c = 12, l = 10, u = (e) => e > 1;
function d(e) {
	let t = parseInt(e, 10);
	if (isNaN(t)) return null;
	let n = Math.floor(t / 100), r = t % 100 / 10;
	return n < 1 || n > 12 || !Number.isInteger(r) || r < 0 || r >= 10 ? null : {
		family: n,
		variant: r
	};
}
function f(e) {
	let t = 0;
	if (e != null) for (let n = 0; n < e.length; n++) t = (t << 5) - t + e.charCodeAt(n), t &= t;
	else t = Math.floor(Math.random() * 1e6);
	let n = Math.abs(t);
	return {
		family: n % 12 + 1,
		variant: Math.floor(n / 12) % 10
	};
}
function p(e, t, n) {
	let r = n * Math.PI / 180, i = t * Math.cos(r), a = t * Math.sin(r), o = e + .3963377774 * i + .2158037573 * a, s = e - .1055613458 * i - .0638541728 * a, c = e - .0894841775 * i - 1.291485548 * a, l = o * o * o, u = s * s * s, d = c * c * c, f = 4.0767416621 * l - 3.3077115913 * u + .2309699292 * d, p = -1.2684380046 * l + 2.6097574011 * u - .3413193965 * d, m = -.0041960863 * l - .7034186147 * u + 1.707614701 * d;
	f = Math.max(0, Math.min(1, f)), p = Math.max(0, Math.min(1, p)), m = Math.max(0, Math.min(1, m));
	let h = (e) => e <= .0031308 ? 12.92 * e : 1.055 * e ** (1 / 2.4) - .055;
	return f = Math.round(h(f) * 255), p = Math.round(h(p) * 255), m = Math.round(h(m) * 255), "#" + [
		f,
		p,
		m
	].map((e) => e.toString(16).padStart(2, "0")).join("");
}
function m(e, t, n) {
	let r = a[t], i = o[t];
	return p(r, i, (n + (s[e] ?? 0)) % 360);
}
var h = {
	AVATAR_SIZE_MODIFIERS: e,
	AVATAR_KIND_MODIFIERS: t,
	AVATAR_PRESENCE_SIZE_MODIFIERS: n,
	AVATAR_PRESENCE_STATES: r,
	AVATAR_ICON_SIZES: i,
	AVATAR_LIGHTNESS: a,
	AVATAR_CHROMA: o,
	AVATAR_HUE_OFFSETS: s,
	AVATAR_FAMILY_COUNT: 12,
	AVATAR_VARIANT_COUNT: 10,
	AVATAR_GROUP_VALIDATOR: u,
	colorToFamilyVariant: d,
	getRandomFamilyVariant: f,
	oklchToHex: p,
	computeAvatarHex: m
};
//#endregion
export { o as AVATAR_CHROMA, c as AVATAR_FAMILY_COUNT, u as AVATAR_GROUP_VALIDATOR, s as AVATAR_HUE_OFFSETS, i as AVATAR_ICON_SIZES, t as AVATAR_KIND_MODIFIERS, a as AVATAR_LIGHTNESS, n as AVATAR_PRESENCE_SIZE_MODIFIERS, r as AVATAR_PRESENCE_STATES, e as AVATAR_SIZE_MODIFIERS, l as AVATAR_VARIANT_COUNT, d as colorToFamilyVariant, m as computeAvatarHex, h as default, f as getRandomFamilyVariant, p as oklchToHex };

//# sourceMappingURL=avatar-constants.js.map